import type {
  EducationDetailDto,
  EducationType,
  VirtualClassroomDto,
} from "../../../types/client-education-detail.types";
import { resolveEducationDisplayDates } from "../../../utils/education-dates";
import { formatDateRangeLong } from "@/utils/date";
import sectionStyles from "../sections.module.scss";
import { VirtualClassroomCard } from "./VirtualClassroomCard";
import styles from "./VirtualClassrooms.module.scss";

export function VirtualClassroomsSection(props: {
  education: EducationDetailDto;
  /** Eğitim tipi — ON_SITE'da Jitsi katılım butonu yerine konum/tarih bilgisi öne çıkar. */
  educationType?: EducationType;
  now?: Date;
  onJoin: (vc: VirtualClassroomDto) => void;
}) {
  const { education, educationType, now = new Date(), onJoin } = props;
  const list = education.virtualClassrooms ?? [];
  if (!list.length) return null;
  // Sınıfların içinde eğitimin başlangıç/bitiş tarihini göster; eğitimin kendi
  // tarihi yoksa sınıf/oturum tarihlerinden türetilir.
  const { start, end } = resolveEducationDisplayDates(education);
  const educationDateText = formatDateRangeLong(start, end) || null;
  return (
    <section id="virtualClassrooms" className={sectionStyles.section}>
      <div className={sectionStyles.header}><h2>Planlanan Oturumlar</h2></div>
      <div className={styles.grid}>
        {list.map((vc) => (
          <VirtualClassroomCard
            key={vc.id}
            vc={vc}
            now={now}
            educationType={educationType ?? (education as { type?: EducationType }).type}
            educationDateText={educationDateText}
            onJoin={onJoin}
          />
        ))}
      </div>
    </section>
  );
}
